import styled from "styled-components";

export const FooterContainer = styled.footer`
  align-items: center;
  background-color: #f76000;
  bottom: 0;
  display: flex;
  flex: none;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 10px;
  height: 500px;
  justify-content: center;
  left: calc(50.00000000000002% - 100% / 2);
  overflow: visible;
  padding: 100px 0 0;
  position: fixed;
  user-select: none;
  width: 100%;
  z-index: 1;
  margin: 0;

  @media (max-width: 768px) {
    height: 300px;
    padding: 40px 20px;
  }
`;

export const FooterContent = styled.div`
  align-items: center;
  display: flex;
  flex: none;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 20px;
  height: min-content;
  justify-content: center;
  overflow: visible;
  padding: 40px 0;
  position: relative;
  width: 100%;
  z-index: 2;

  @media (max-width: 768px) {
    gap: 24px;
  }
`;

export const FooterLogo = styled.div`
  flex: none;
  height: auto;
  position: relative;
  white-space: pre;
  width: auto;
  outline: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-shrink: 0;
  transform: none;
`;

export const LogoText = styled.p`
  font-family: "Changa One", sans-serif;
  font-size: 28px;
  text-align: center;
  color: #000;
  font-weight: 400;
  line-height: 120%;

  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

export const SocialLinks = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
  display: flex;
  flex: none;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 10px;
  height: 80px;
  justify-content: center;
  overflow: hidden;
  padding: 0;
  position: relative;
  width: 186px;

  @media (max-width: 768px) {
    gap: 16px;
  }
`;

export const SocialIcon = styled.a`
  display: block;
  flex: none;
  height: 41px;
  position: relative;
  text-decoration: none;
  width: 40px;

  @media (max-width: 768px) {
    width: 32px;
    height: 32px;
  }
`;

export const Copyright = styled.h2`
  outline: none;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex-shrink: 0;
  will-change: transform;
  opacity: 1;
  transform: perspective(1200px);
  font-family: "Manrope", "Manrope Placeholder", sans-serif;
  font-size: 18px;
  letter-spacing: -0.03em;
  line-height: 120%;
  text-align: center;
  color: #000;
  font-weight: 400;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;
